// extracted by mini-css-extract-plugin
export default {"pageTitle":"emp_src-pages-livelens-index__pageTitle--Qcjw9"};